// frontend/src/utils/axios.ts
import axios from 'axios';
import { logout, refreshAccessToken } from './auth';

// Base URL will be different in dev vs prod
// const baseURL = import.meta.env.PROD 
//   ? 'https://fifteenshared.net/' 
//   : 'http://localhost:5200/';
const baseURL='/';

axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json';
    config.withCredentials = true;
    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401
            && !originalRequest._retry
            && !originalRequest.url?.includes('/api/Auth/refresh')) {
            originalRequest._retry = true; // Prevent infinite loops

            const refreshed = await refreshAccessToken();

            if (refreshed) {
                return axios(originalRequest);
            } else {
                // Refresh failed, redirect to login
                logout();
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

export default axios;